export default __webpack_public_path__ + "static/media/4.e3e7d0ef.png";